/*
 * @Author: huangyi
 * @Date: 2024-03-25 11:13:38
 * @LastEditors: huangyi
 * @LastEditTime: 2024-03-25 13:10:23
 * @Description: 埋点
 */

export const state = () => ({
    pointList: [], // 埋点列表
})
export const mutations = {
    // 获取埋点列表
    SET_POINT_LIST: (state, list) => {
        state.pointList = list
    },
}
export const actions = {
    PointList({ commit, state }, params) {
        console.log("🚀 ~ PointList ~ params:", params)
        commit('SET_POINT_LIST', [...state.pointList, { eventId: '', ...params }])
        if (state.pointList.length > 5) {
            return new Promise((resolve, reject) => {
                this.$api
                    .monitorHitBatch({
                        action: {
                            events: state.pointList
                        }
                    })
                    .then((res) => {
                        commit('SET_POINT_LIST', [])
                        resolve(res)
                    })
                    .catch((error) => {
                        commit('SET_POINT_LIST', [])
                        reject(error)
                    })
            })
        }
    }
}
export const getters = {
    pointList: (state) => state.pointList,
}
